import styled from 'styled-components';

const StyledColumns = styled.div`
	display: grid;
	grid-template-columns: repeat(2, minmax(10rem, 1fr));
	justify-items: start;
	${({isStandard}) => isStandard && `row-gap:  var(--spacing-medium);`};
	column-gap: var(--spacing-xx-large);
	flex: 1;
	justify-items: stretch;
	.columns {
		min-width: 0;
		display: flex;
		gap: var(--spacing-small);
		.motif-checkbox-wrapper {
			min-width: 0;
			flex: 1;
		}
		.motif-icon-button {
			opacity: 0;
			transition: opacity 0.2s ease-in-out;
			pointer-events: none;
		}
		&:hover {
			.motif-icon-button {
				opacity: 1;
				pointer-events: auto;
			}
		}
	}

	@media (max-width: 1280px) {
		${({isProjectOwner}) => isProjectOwner && `grid-template-columns: repeat(1, minmax(10rem, 1fr));`};
		.checkoption-item {
			max-width: calc(100% - 4.2rem);
		}
	}
`;

const StyledBody = styled.div`
	gap: var(--spacing-medium);
	display: flex;
	flex-direction: column;
	padding-bottom: var(--spacing-medium);
`;

export {StyledColumns, StyledBody};
